/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AuthPrincipalInfo,
  AuthPrincipalInfo$inboundSchema,
  AuthPrincipalInfo$Outbound,
  AuthPrincipalInfo$outboundSchema,
} from "./authprincipalinfo.js";

/**
 * Indication that the Gaia session is pre-authenticated via AgentProxy Mode (aka Local Online Mode).
 */
export type PreauthenticationConfig = {
  /**
   * Comprehensive information about an ATLAS authentication principal.
   */
  principal: AuthPrincipalInfo;
};

/** @internal */
export const PreauthenticationConfig$inboundSchema: z.ZodType<
  PreauthenticationConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  principal: AuthPrincipalInfo$inboundSchema,
});
/** @internal */
export type PreauthenticationConfig$Outbound = {
  principal: AuthPrincipalInfo$Outbound;
};

/** @internal */
export const PreauthenticationConfig$outboundSchema: z.ZodType<
  PreauthenticationConfig$Outbound,
  z.ZodTypeDef,
  PreauthenticationConfig
> = z.object({
  principal: AuthPrincipalInfo$outboundSchema,
});

export function preauthenticationConfigToJSON(
  preauthenticationConfig: PreauthenticationConfig,
): string {
  return JSON.stringify(
    PreauthenticationConfig$outboundSchema.parse(preauthenticationConfig),
  );
}
export function preauthenticationConfigFromJSON(
  jsonString: string,
): SafeParseResult<PreauthenticationConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PreauthenticationConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PreauthenticationConfig' from JSON`,
  );
}
